/** The ID of the tooltip element used to locate it in the DOM */
export const ELEMENT_ID = 'scalar-tooltip' as const

/** The class name of the tooltip element */
export const ELEMENT_CLASS = 'scalar-tooltip' as const

/** The default delay for the tooltip */
export const DEFAULT_DELAY = 300 as const

/** The default offset for the tooltip */
export const DEFAULT_OFFSET = 4 as const
